import ApiClient from '../ApiClient';

class MyAiBulkActionsAPI extends ApiClient {
  constructor() {
    super('my_ai/bulk_actions', { accountScoped: true });
  }
}

export default new MyAiBulkActionsAPI();
